import React, { useState } from 'react';
import ExpertDetailsModal from '@/components/Modal/ExpertDetailsModal';
import { ExpertData } from '@/types/expert';
import PartnerModal from '@/components/Modal/PartnerModal';
import { transformExpertData, transformPartnerData } from '@/utils/modalUtils';
import { Partner } from '@/types/partner';
import { getExpert, getPartner } from '@/services/strapiService';
import { useSelectedLanguage } from '@/redux/selectors/languageSelector';
import { SearchableStrapiEntities, SearchHit } from '@/types/search';
import { T } from '@tolgee/react';
const Hit = ({
  id,
  title,
  description,
  type
}: SearchHit) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [strapiEntity, setStrapiEntity] = useState<ExpertData | Partner>();
  const locale = useSelectedLanguage();
  const openModal = () => {
    if (strapiEntity === undefined) {
      if (type === SearchableStrapiEntities.experts) {
        getExpert(id.toString(), locale).then(result => {
          setStrapiEntity(result.data);
          setIsModalOpen(true);
        });
      } else if (type === SearchableStrapiEntities.partners) {
        getPartner(id.toString(), locale).then(result => {
          setStrapiEntity(result.data);
          setIsModalOpen(true);
        });
      }
    } else {
      setIsModalOpen(true);
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return <>
      <div key={id} className="grid grid-cols-[auto_1fr] gap-3 p-3.5 rounded-md items-center cursor-pointer hover:bg-gray" onClick={openModal}>
        <div className="flex flex-col">
          <div className="text-base mb-1">
            {title}{' '}
            <span className="text-sm font-semibold opacity-50">
              {' '}
              • <T data-sentry-element="T" data-sentry-source-file="Hit.tsx">{'search.result_type.' + type + '.tag.label'}</T>{' '}
            </span>
          </div>
          <div className="text-sm font-semibold opacity-50 font-poppins">{description}</div>
        </div>
      </div>
      {isModalOpen && type == SearchableStrapiEntities.experts && <ExpertDetailsModal expert={transformExpertData(strapiEntity as ExpertData)} isOpen={isModalOpen} onClose={closeModal} />}
      {isModalOpen && type == SearchableStrapiEntities.partners && <PartnerModal partner={transformPartnerData(strapiEntity as Partner)} isOpen={isModalOpen} onClose={closeModal} handleIsLimitReached={() => {}} />}
    </>;
};
export default Hit;